import React, { useEffect, useState } from "react";
import DaterangePicker from "../../common/Daterangepicker";
import formatDate from "../../common/Formatdate";
import Task from "../../assets/task.png";
import Completed from "../../assets/checked.png";
import Pending from "../../assets/work-in-progress.png";
import Urgent from "../../assets/alarm.png";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  IconButton,
  useMediaQuery,
  Typography,
  TablePagination,
  TextField,
  Autocomplete,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Bookingdetailstab from "./Bookingdetailstab";
import commonapihandler from "../../common/commonapihandler";
import { getHubName } from "../../api/api";
import formatDateAndTime from "../../common/formatDateAndTime";
import { BlinkBlur } from "react-loading-indicators";
import toast from "react-hot-toast";
import moment from "moment";
import Bookingdetailstab1 from "./Bookingdetailstab1";
import { camelToNormal } from "../../common/caseconversion";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { DataGrid } from "@mui/x-data-grid";
import Commongrid from "../../common/Commongrid";
import { useSelector } from "react-redux";

function createData(
  id,
  source,
  bookingCode,
  bookingType,
  vehicleName,
  vehicleNo,
  createdAt,
  confirmedAt,
  startdate,
  enddate,
  customername,
  customermobile,
  customeremail,
  assignedTo,
  deliverydetails,
  pickupdetails,
  city,
  hub,
  bookingstatus,
  inquiryID,
  // inquiryaging,
  amount,
  action
) {
  return {
    id,
    source,
    bookingCode,
    bookingType,
    vehicleName,
    vehicleNo,
    createdAt,
    confirmedAt,
    startdate,
    enddate,
    customername,
    customermobile,
    customeremail,
    assignedTo,
    deliverydetails,
    pickupdetails,
    city,
    hub,
    bookingstatus,
    inquiryID,
    // inquiryaging,
    amount,
    action,
  };
}

const Viewallbookingdashboard = ({ setActiveItem }) => {
  const querydisplay = new URLSearchParams(window.location.search).get(
    "display"
  );
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const isSystemUserDataList = useSelector((state) => state?.isSystemUser?.isSysTemUserData?.entities?.rows)
  const isMobile = useMediaQuery("(max-width:768px)");
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAgo.setHours(0, 0, 0, 0);

  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });
  const [dateFitlerBy, setDateFilterBy] = useState("createdAt");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [openTab, setOpenTab] = useState(false);
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState("");
  const [hubs, setHubs] = useState(null);
  const [hub, setHub] = useState("");
  const [allBookings, setAllBookings] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const bookingStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.fleetBookingStatus;
  delete bookingStatus?.inverted;
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.fleetBookingStatus;
  let bookingTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  let bookingTypesDuplicate = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  delete bookingTypesDuplicate?.inverted
  const fleetBookingvalue = bookingStatus;

  const filteredKeys = Object.keys(fleetBookingvalue).filter(
    (key) => !fleetBookingvalue[key].includes("Inquiry")
  );
  
  const [sourceVal, setSourceVal] = useState("");
  const [vehicleListings, setVehicleListings] = useState([]);
  const [vehicleId, setVehicleId] = useState(null);
  const [selectedSearchButton, setSelectedSearchButton] = useState("");
  const [searchValues, setSearchValues] = useState(null);
  const [bookingstatus, setBookingStatus] = useState(null);
  const [bookingTypesStatus, setBookingTypes] = useState(null);
  const [getAllHubsListData, setGetAllHubsListData] = useState(null);
  const [copied, setCopied] = useState(false);
  const catalogRoles = JSON.parse(localStorage.getItem("catalogValues"))?.role
    ?.inverted?.franchiseAdmin;
  const catalogRActions = JSON.parse(localStorage.getItem("catalogValues"))
    ?.action?.inverted?.viewMyCityBookings;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [isFilter, setIsFilter] = useState(false);

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 70,
      align: "center",
      sortable: false,
    },
    {
      field: "source",
      headerName: "Source",
      minWidth: 70,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            bgcolor: "#ebfff2ff",
            fontWeight: 700,
            px: 1,
            py: 0.5,
            borderRadius: 1,
            textAlign: "center",
            width: "100%",
          }}
        >
          {params.value || "-"}
        </Box>
      ),
    },
    {
      field: "bookingCode",
      headerName: "Booking ID",
      minWidth: 180,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "bookingstatus",
      headerName: "Booking Status",
      minWidth: 200,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            justifyContent: "center",
          }}
        >
          <span style={{ color: "#0a0aa8ff", fontWeight: 700 }}>
            {params.value || "-"}
          </span>
        </Box>
      ),
    },
    {
      field: "bookingType",
      headerName: "Booking Type",
      minWidth: 250,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            bgcolor: "rgb(255, 235, 235)",
            fontWeight: 700,
            px: 1,
            py: 0.5,
            borderRadius: 1,
            textAlign: "center",
            width: "100%",
          }}
        >
          {params.value || "-"}
        </Box>
      ),
    },
    {
      field: "vehicleName",
      headerName: "Vehicle Name",
      minWidth: 150,
      align: "center",
      sortable: false,
    },
    {
      field: "vehicleNo",
      headerName: "Vehicle No",
      minWidth: 150,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "startdate",
      headerName: "Start Date",
      minWidth: 190,
      align: "center",
    },
    {
      field: "enddate",
      headerName: "End Date",
      minWidth: 190,
      align: "center",
    },
    {
      field: "deliverydetails",
      headerName: "Delivery Type",
      minWidth: 150,
      align: "center",
      sortable: false,
    },
    {
      field: "pickupdetails",
      headerName: "Pickup Type",
      minWidth: 120,
      align: "center",
      sortable: false,
    },
    {
      field: "customername",
      headerName: "Customer Name",
      minWidth: 150,
      align: "center",
      sortable: false,
    },
    {
      field: "customermobile",
      headerName: "Customer Mobile",
      minWidth: 150,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "customeremail",
      headerName: "Customer Email",
      minWidth: 200,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "assignedTo",
      headerName: "Assigned To",
      minWidth: 180,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            justifyContent: "center",
          }}
        >
          <span style={{ color: "rgb(18, 15, 228)", fontWeight: 700 }}>
            {params.value || "-"}
          </span>
        </Box>
      ),
    },
    {
      field: "createdAt",
      headerName: "Inquiry Created At",
      minWidth: 190,
      align: "center",
    },
    {
      field: "confirmedAt",
      headerName: "Booking Confirmed At",
      minWidth: 190,
      align: "center",
    },
    {
      field: "city",
      headerName: "City",
      minWidth: 100,
      align: "center",
      sortable: false,
    },
    {
      field: "hub",
      headerName: "Hub",
      minWidth: 150,
      align: "center",
      sortable: false,
    },
    {
      field: "inquiryID",
      headerName: "Inquiry ID",
      minWidth: 205,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    // {
    //   id: "inquiryaging",
    //   headerName: "Inquiry Aging",
    //   minWidth: 150,
    //   align: "center",
    // },
    {
      field: "amount",
      headerName: "Amount",
      minWidth: 140,
      align: "center",
      format: (value) => value?.toFixed(2),
    },
    // { id: "action", headerName: "Action", minWidth: 90, align: "center" },
  ];

  const searchByFilter = [
    {
      label: "Booking Id",
      value: "bookingCode",
    },
    // {
    //   label: "Inquiry Id",
    //   value: "inquiryCode",
    // },
    {
      label: "Customer Email",
      value: "contactEmail",
    },
    {
      label: "Customer Contact",
      value: "customerContactNo",
    },
    // {
    //   label: "Source",
    //   value: "source",
    // },
    {
      label: "Vehicle Registration",
      value: "vehicleRegistrationNo",
    },
  ];

  const rows =
    (allBookings && allBookings.length > 0 &&
      allBookings?.map((item) =>
        createData(
          item?.id,
          camelToNormal(item?.source),
          item?.bookingCode,
          (bookingTypes[item?.bookingType]  || bookingTypes[Number(bookingTypes?.inverted?.dailyRental)]) + `(${moment(item?.bookTo).diff(moment(item?.bookFrom), "hours") < 24 ? `${moment(item?.bookTo).diff(moment(item?.bookFrom), "hours")} hours` : `${Math.floor(moment(item?.bookTo).diff(moment(item?.bookFrom), "hours") / 24)} days`})`,
          item?.vehicleName || "/",
          item?.vehicleRegistrationNo || "/",
          formatDateAndTime(item?.createdAt),
          formatDateAndTime(item?.bookingGeneratedOn),
          formatDateAndTime(item?.bookFrom),
          formatDateAndTime(item?.bookTo),
          item?.customerName,
          item?.customerMobile,
          item?.customerEmail,
          isSystemUserDataList.find((user) => user.id === item?.assignedAgent)?.name || "-",
          camelToNormal(item?.deliveryType),
          camelToNormal(item?.pickupType),
          item?.cityId && cities[item?.cityId],
          getAllHubsListData.find((hub) => hub?.id === item?.hubId)?.hubName ||
            "-",
          fleetBookingStatus[item?.bookingStatus] || "-",
          item?.inquiryCode,
          // fleetBookingStatus[item?.bookingStatus] !== "Inquiry"
          //   ? "-"
          //   : `${moment().diff(moment(item?.createdAt), "days") || 0} days`,
          "₹ " + item?.costToCustomer
          // "View"
        )
      )) ||
    [];

  useEffect(() => {
    if (querydisplay) {
      setOpenTab(true);
    }
  }, [querydisplay]);
  

  function formatDateForApi(date) {
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formattedStartDate = formatDateForApi(selectionRange?.startDate);
  const formattedEndDate = formatDateForApi(selectionRange?.endDate);

  const searchOnTheFilterBy = async (
    customPage = page,
    customRowsPerPage = rowsPerPage
  ) => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    const offset = (customPage ?? 0) * (customRowsPerPage ?? rowsPerPage);
    let query = "";

    if (searchValues && !selectedSearchButton) {
      return toast.error("Please select the search by category", {
        position: "top-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      });
    }
    if (selectedSearchButton && !searchValues) {
      return toast.error("Please enter the search value", {
        position: "top-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      });
    }

    if (selectedSearchButton === "bookingCode") {
      query += `&bookingCode=${searchValues}`;
    } else if (selectedSearchButton === "inquiryCode") {
      query += `&inquiryCode=${searchValues}`;
    } else if (selectedSearchButton === "contactEmail") {
      query += `&customerEmail=${searchValues}`;
    } else if (selectedSearchButton === "customerContactNo") {
      query += `&customerMobile=${searchValues}`;
    } else if (selectedSearchButton === "vehicleRegistrationNo") {
      query += `&vehicleRegistrationNo=${searchValues}`;
    }

    if (
      profile?.roles.includes(Number(catalogRoles)) ||
      profile?.actions.includes(Number(catalogRActions))
    ) {
      query += `&cityId=${profile?.cityId}`;
    }

    if (bookingstatus) {
      query += `&bookingStatus=${bookingstatus}`;
    }

    if (bookingTypesStatus) {
      query += `&bookingType=${bookingTypesStatus}`;
    }

    if (city) {
      query += `&cityId=${city}`;
    } else if (
      profile?.roles.includes(Number(catalogRoles)) ||
      profile?.actions.includes(Number(catalogRActions))
    ) {
      query += `&cityId=${profile?.cityId}`;
    }

    if (hub) {
      query += `&hubId=${hub}`;
    }

    if (sourceVal && sourceVal !== "All") {
      query += `&source=${sourceVal}`;
    }

    if (dateFitlerBy && formattedStartDate && formattedEndDate) {
      query += `&dateType=${dateFitlerBy}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/advancesearch/bookings?limit=${customRowsPerPage}&offset=${offset}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);

        setAllBookings(data?.dataValues?.rows);
        // setAllBookings(data?.entities?.rows);
        setTotalCount(data?.dataValues?.count || 0);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    getCityNames();
    getAllBookings();
    getAllHubsList();
  }, []);

  const getAllHubsList = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hubs?limit=1000`);
      const data = await response.json();
      if (data?.statusCode === "0100")
        setGetAllHubsListData(data?.entities?.rows);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const handleCityChange = (event) => {
    setPage(0);
    const value = event.target.value;
    setCity(value);
    getHubNames(value);
  };

  const getHubNames = async (value) => {
    const apiDetails = await getHubName(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows || []);
  };

  const handleHubChange = (event) => {
    setPage(0);
    setHub(event.target.value);
  };

  const getAllBookings = async (
    customPage = page,
    customRowsPerPage = rowsPerPage
  ) => {
    setLoading(true);
    const offset = (customPage ?? 0) * (customRowsPerPage ?? rowsPerPage);
    let query = "";

    if (filteredKeys) {
      query += `&bookingStatus=[${filteredKeys}]`;
    }

    if (
      profile?.roles.includes(Number(catalogRoles)) ||
      profile?.actions.includes(Number(catalogRActions))
    ) {
      query += `&cityId=${profile?.cityId}`;
    }
    // else if (profile?.actions.includes(Number(catalogRActions))) {
    //   query += `&cityId=${profile?.cityId}`;
    // }

    try {
      const response = await fetch(
        `${apiUrl}/api/vehiclebookings?limit=${customRowsPerPage}&offset=${offset}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setAllBookings(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);

    if (
      bookingstatus ||
      city ||
      hub ||
      sourceVal ||
      selectedSearchButton ||
      dateFitlerBy
    ) {
      searchOnTheFilterBy(0, newRowsPerPage);
    } else {
      getAllBookings(0, newRowsPerPage);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);

    if (
      bookingstatus ||
      city ||
      hub ||
      sourceVal ||
      selectedSearchButton ||
      dateFitlerBy
    ) {
      searchOnTheFilterBy(newPage, rowsPerPage);
    } else {
      getAllBookings(newPage, rowsPerPage);
    }
  };

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setOpenTab(true);
  };

  return (
    <>
      {!openTab ? (
        <>
          <div className="my-4 text-xl md:text-2xl px-2 font-bold flex justify-between">
            <h1>Bookings List</h1>
            <button
              onClick={() => {
                setPaginationModel({ page: 0, pageSize: 20 });
                getAllBookings();
              }}
              class="p-5 rounded-full backdrop-blur-lg border border-green-500/20 bg-gradient-to-tr from-white/60 to-white/40 shadow-lg hover:shadow-2xl hover:shadow-green-500/30 hover:scale-110 hover:rotate-2 active:scale-95 active:rotate-0 transition-all duration-300 ease-out cursor-pointer hover:border-green-500/50 hover:bg-gradient-to-tr hover:from-green-500/10 hover:to-white/40 group relative overflow-hidden"
            >
              <div class="absolute inset-0 bg-gradient-to-r from-transparent via-green-400/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out"></div>
              <div class="relative z-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="100"
                  height="100"
                  viewBox="0 0 30 30"
                  className="w-4 h-4"
                >
                  <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
                </svg>
              </div>
            </button>
          </div>
          <Box p={isMobile ? 2 : 1}>
            <Box
              display="flex"
              flexDirection="column"
              p={2}
              borderRadius={2}
              boxShadow={3}
              mb={4}
              sx={{ backgroundColor: "white" }}
            >
              {/* Top Header Row */}
              <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", md: "center" }}
                mb={3}
                gap={2}
              >
                {/* <Button
                  variant="contained"
                  startIcon={
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 4v12"
                      />
                    </svg>
                  }
                >
                  Export
                </Button> */}
              </Box>

              <Box
                display="grid"
                gridTemplateColumns={{
                  xs: "1fr",
                  sm: "repeat(2, 1fr)",
                  lg: "repeat(8, 1fr)",
                }}
                gap={2}
                mb={3}
              >
                <h1 className="mt-2">Filter By :</h1>

                <FormControl fullWidth size="small">
                  <InputLabel id="hub-select-label">Date Filter</InputLabel>
                  <Select
                    labelId="hub-select-label"
                    id="hub-select"
                    value={dateFitlerBy}
                    onChange={(e) => {
                      setPage(0);
                      setDateFilterBy(e.target.value);
                    }}
                  >
                    <MenuItem value="createdAt">Created At</MenuItem>
                    <MenuItem value="bookFrom">Start Date</MenuItem>
                    <MenuItem value="bookTo">End Date</MenuItem>
                  </Select>
                </FormControl>

                {/* Date Range Picker */}
                {/* <Paper elevation={3} sx={{ p: 1.5, borderRadius: 2 }}> */}
                <DaterangePicker
                  selectionRange={selectionRange}
                  setSelectionRange={setSelectionRange}
                />
                {/* </Paper> */}

                <FormControl fullWidth size="small">
                  <InputLabel id="city-select-label">Booking Status</InputLabel>
                  <Select
                    labelId="city-select-label"
                    id="city-select"
                    value={bookingstatus}
                    onChange={(e) => {
                      setPage(0);
                      setBookingStatus(e.target.value);
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 200, // Limits dropdown height (optional)
                        },
                      },
                    }}
                  >
                    {bookingStatus &&
                      Object.entries(bookingStatus).map(([key, value]) => (
                        <MenuItem
                          sx={{
                            minHeight: 20, // Smaller height
                            paddingY: 0.5, // Compact vertical padding
                            fontSize: "0.8rem", // Smaller font (optional)
                          }}
                          key={key}
                          value={key}
                        >
                          {value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth size="small">
                  <InputLabel id="resntal-select-label">Rental Types</InputLabel>
                  <Select
                    labelId="resntal-select-label"
                    id="resntal-select"
                    value={bookingTypesStatus}
                    onChange={(e) => {
                      setPage(0);
                      setBookingTypes(e.target.value);
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 200, // Limits dropdown height (optional)
                        },
                      },
                    }}
                  >
                    {bookingTypesDuplicate &&
                      Object.entries(bookingTypesDuplicate).map(([key, value]) => (
                        <MenuItem
                          sx={{
                            minHeight: 20, // Smaller height
                            paddingY: 0.5, // Compact vertical padding
                            fontSize: "0.8rem", // Smaller font (optional)
                          }}
                          key={key}
                          value={key}
                        >
                          {value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                {profile?.roles.includes(Number(catalogRoles)) ||
                  (profile?.actions.includes(Number(catalogRActions)) ? (
                    <></>
                  ) : (
                    <FormControl fullWidth size="small">
                      <InputLabel id="city-select-label">City</InputLabel>
                      <Select
                        labelId="city-select-label"
                        id="city-select"
                        value={city}
                        onChange={handleCityChange}
                      >
                        {cities &&
                          Object.entries(cities).map(([key, value]) => (
                            <MenuItem key={key} value={key}>
                              {value}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  ))}

                {profile?.actions.includes(Number(catalogRActions)) ||
                  (profile?.actions.includes(Number(catalogRActions)) ? (
                    <></>
                  ) : (
                    <FormControl fullWidth size="small">
                      <InputLabel id="hub-select-label">Hub</InputLabel>
                      <Select
                        labelId="hub-select-label"
                        id="hub-select"
                        value={hub}
                        onChange={handleHubChange}
                      >
                        {
                          // hubs?.length ? (
                          getAllHubsListData &&
                            getAllHubsListData.map((item, index) => (
                              <MenuItem key={index} value={item?.id}>
                                {item?.hubName}
                              </MenuItem>
                            ))
                          // ) : (
                          //   <MenuItem value="">
                          //     <em>Select City First</em>
                          //   </MenuItem>
                          // )
                        }
                      </Select>
                    </FormControl>
                  ))}

                <FormControl fullWidth size="small">
                  <InputLabel id="status-select-label">Source</InputLabel>
                  <Select
                    labelId="status-select-label"
                    id="status-select"
                    value={sourceVal}
                    onChange={(e) => {
                      setPage(0);
                      setSourceVal(e.target.value);
                    }}
                    MenuProps={{
                      PaperProps: { sx: { maxHeight: 200 } },
                    }}
                  >
                    <MenuItem key="All" value="All" className="text-sm">
                      All
                    </MenuItem>
                    <MenuItem key="mobileapp" value="mobileapp" className="text-sm">
                      Mobile App
                    </MenuItem>
                    <MenuItem key="website" value="website" className="text-sm">
                      Website
                    </MenuItem>
                    <MenuItem key="admin" value="admin" className="text-sm">
                      Admin
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>

              <div className="grid grid-cols-12 mt-2">
                <h1 className="mt-2 col-span-2 text-start">Search By :</h1>
                <div className="col-span-9 flex gap-4">
                  {searchByFilter.map((item, index) => {
                    const isActive = item?.value === selectedSearchButton;
                    return (
                      <div key={index}>
                        <button
                          onClick={() => {
                            setPage(0);
                            setSearchValues(null);
                            setSelectedSearchButton(item?.value);
                          }}
                          className={`h-[40px] w-40 rounded-xl flex items-center justify-center transition-transform duration-200 active:scale-[0.95] border
              ${
                isActive
                  ? "bg-[linear-gradient(45deg,#efad21,#ffd60f)] border-transparent text-white font-medium text-md shadow-md"
                  : "bg-white border-black text-black hover:bg-gray-100"
              }`}
                        >
                          <span className="font-normal leading-none transition-all duration-200">
                            {item?.label}
                          </span>
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="mt-8 grid grid-cols-12 gap-16">
                <div className="col-span-10">
                  <TextField
                    fullWidth
                    id="standard-basic"
                    label="Enter the value to search"
                    variant="standard"
                    value={searchValues}
                    onChange={(e) => {
                      setPage(0);
                      setSearchValues(e.target.value);
                    }}
                  />
                </div>

                <div className="col-span-2 flex items-center gap-4">
                  <button
                    onClick={() => {
                      setIsFilter(true);
                      setPaginationModel({ page: 0, pageSize: 20 });
                      setPage(0);
                      searchOnTheFilterBy();
                    }}
                    className="w-12 h-12 rounded-full bg-violet-500 group shadow-xl flex items-center justify-center relative overflow-hidden"
                  >
                    <svg
                      className="w-6 h-6 text-gray-800 relative z-10 dark:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                      />
                    </svg>

                    <div className="w-full h-full rotate-45 absolute left-[32%] top-[32%] bg-green-500 group-hover:-left-[100%] group-hover:-top-[100%] duration-1000"></div>
                    <div className="w-full h-full -rotate-45 absolute -left-[32%] -top-[32%] group-hover:left-[100%] group-hover:top-[100%] bg-green-500 duration-1000"></div>
                  </button>

                  <button
                    onClick={() => {
                      setPaginationModel({ page: 0, pageSize: 20 });
                      setCity("");
                      setHub("");
                      setPage(0);
                      setDateFilterBy("createdAt");
                      setSelectedSearchButton(null);
                      setSearchValues(null);
                      setBookingStatus(null);
                      getAllBookings();
                      setBookingTypes("")
                      setSourceVal("");
                      setSelectionRange({
                        startDate: oneMonthAgo,
                        endDate: today,
                        key: "selection",
                      });
                    }}
                    class="cursor-pointer transition-all bg-blue-500 text-white px-4 py-2 rounded-lg
border-blue-600
border-b-[4px] hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px]
active:border-b-[2px] active:brightness-90 active:translate-y-[2px]"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </Box>

            <Paper
              sx={{
                // width: "80%",
                boxShadow: 6,
                borderRadius: 2,
                mt: 4,
              }}
            >
              {/* <DataGrid
                rows={rows}
                columns={columns}
                paginationMode="server"
                rowCount={totalCount} // total rows from API
                paginationModel={paginationModel}
                onPaginationModelChange={(model) => {
                  setPaginationModel(model);
                  getAllBookings(model.page, model.pageSize); // API call
                }}
                onRowClick={(params) => handleViewClick(params.row)}
                loading={loading}
                autoHeight
                pageSizeOptions={[20, 40, 80]}
                className="cursor-pointer"
                disableColumnMenu
              /> */}

              <Commongrid
                rows={rows}
                columns={columns}
                totalCount={totalCount} // total rows from API
                handleViewClick={handleViewClick}
                api={
                  selectedSearchButton ||
                  city ||
                  hub ||
                  sourceVal ||
                  bookingstatus ||
                  isFilter
                    ? searchOnTheFilterBy
                    : getAllBookings
                }
                setPaginationModel={setPaginationModel}
                paginationModel={paginationModel}
                loading={loading}
                disableColumnMenu={true}
              />

              {/* <TableContainer
                sx={{
                  // maxHeight: 500,
                  overflowX: "scroll", // ✅ horizontal scroll only if needed
                }}
              >
                <Table stickyHeader aria-label="bookings table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          sx={{
                            backgroundColor: "#f8f7f6ff",
                            fontWeight: 300,
                          }}
                          key={column.id}
                          align={column.align || "left"}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          <div className="flex flex-row gap-40 items-center h-40 justify-center">
                            <BlinkBlur
                              color={[
                                "#cd8032",
                                "#32cd32",
                                "#327fcd",
                                "#cd32cd",
                              ]}
                            />
                            <BlinkBlur
                              color={[
                                "#cd8032",
                                "#32cd32",
                                "#327fcd",
                                "#cd32cd",
                              ]}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : rows.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          <h1 className="mt-10 text-lg font-bold">
                            No Data Found
                          </h1>
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows.map((row, idx) => (
                        <TableRow hover key={idx}>
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                sx={{
                                  ...(column.id === "inquiryaging"
                                    ? {
                                        color: "#fc7070ff",
                                        fontWeight: 900,
                                      }
                                    : {}),
                                  ...(column.id === "source"
                                    ? {
                                        bgcolor: "#ebfff2ff",
                                        fontWeight: 900,
                                      }
                                    : {}),
                                  ...(column.id === "bookingstatus"
                                    ? {
                                        color: "#1c1e85ff",
                                        fontWeight: 900,
                                      }
                                    : {}),
                                  cursor: "pointer",
                                }}
                                onClick={() => handleViewClick(row)}
                                key={column.id}
                                align={column.align}
                              >
                                {column.id === "action" ? (
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => handleViewClick(row)}
                                  >
                                    View
                                  </Button>
                                ) : column.id === "bookingCode" ||
                                  column.id === "inquiryID" ||
                                  column?.id === "customermobile" ||
                                  column?.id === "customeremail" ||
                                  column?.id === "vehicleNo" ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <span>{value || "-"}</span>
                                    {value && (
                                      <>
                                        {" "}
                                        <ContentCopyIcon
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            navigator.clipboard.writeText(
                                              value
                                            );
                                            setCopied(true);
                                            setTimeout(
                                              () => setCopied(false),
                                              1500
                                            );
                                          }}
                                          sx={{
                                            fontSize: 20,
                                            cursor: "pointer",
                                            color:
                                              copied === value
                                                ? "green"
                                                : "grey",
                                            transition: "color 0.2s",
                                          }}
                                        />                                      
                                      </>
                                    )}
                                  </Box>
                                ) : column.format &&
                                  typeof value === "number" ? (
                                  column.format(value)
                                ) : (
                                  value || "-"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[20, 30, 40]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  ".MuiTablePagination-toolbar": {
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                  },
                }}
              /> */}
            </Paper>
          </Box>
        </>
      ) : (
        <>
          <Bookingdetailstab
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            setOpenTab={setOpenTab}
            getAllBookings={getAllBookings}
            getAllHubsListData={getAllHubsListData}
            setCity={setCity}
            setHub={setHub}
            setDateFilterBy={setDateFilterBy}
            setBookingStatus={setBookingStatus}
            setSelectedSearchButton={setSelectedSearchButton}
            setSearchValues={setSearchValues}
            setActiveItem={setActiveItem}
          />
          {/* <Bookingdetailstab1 selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            setOpenTab={setOpenTab}
            getAllBookings={getAllBookings} /> */}
        </>
      )}
    </>
  );
};

export default Viewallbookingdashboard;
